<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form [formGroup]="form" nzLayout="vertical">
    <nz-form-item>
      <nz-form-label *ngIf="dislikeType" nzRequired [nzFor]="'message'">
        {{ 'LOT_TRANSLATION_FEEDBACK.DISLIKE_REASON' | translate }}
      </nz-form-label>
      <nz-form-control [nzErrorTip]="messageErrorTpl">
        <nz-textarea-count [nzMaxCharacterCount]="MAX_LENGTH">
          <textarea
            nz-input
            id="message"
            formControlName="message"
            [rows]="4"
            [placeholder]="messagePlaceholder | translate"
          ></textarea>
        </nz-textarea-count>
      </nz-form-control>
    </nz-form-item>
  </form>
</nz-spin>

<ng-template #messageErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">
    {{ 'LOT_TRANSLATION_FEEDBACK.COMMENT_REQUIRED' | translate }}
  </ng-container>
  <ng-container *ngIf="control.hasError('maxlength')">
    {{ 'LOT_TRANSLATION_FEEDBACK.VALIDATION_MAX' | translate: { max: MAX_LENGTH } }}
  </ng-container>
</ng-template>

<ng-container *nzModalFooter>
  <button
    nz-button
    nzType="primary"
    type="button"
    [disabled]="form?.invalid"
    [nzLoading]="loading$ | async"
    (click)="createOrUpdateFeedback()"
  >
    {{ 'SEND' | translate }}
  </button>
  <button nz-button type="button" (click)="close()">
    {{ 'CANCEL' | translate }}
  </button>
</ng-container>
